import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=69564f00&scoped=true&"
var script = {}
import style0 from "./Preloader.vue?vue&type=style&index=0&id=69564f00&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69564f00",
  null
  
)

export default component.exports